import React  from 'react';
import classnames from 'classnames';

const IdUploaded = ({
  idPhoto, selfie, onNext, magicLinkSentFromMobile, registrationSubmittedAt, idValidated
}) => (
  <div className="columns medium-10 large-8 verification-done">
    <div className="step-header">
      <h3>
        <i className={classnames("fa fa-check-circle text-success", {
          "fa-2x": magicLinkSentFromMobile === false
        })} />{' '}
        { magicLinkSentFromMobile === false && <br className="show-for-small-only" /> }
        { magicLinkSentFromMobile === false? "Nice work!" : "ID and Selfie Submitted!" }
      </h3>

      { magicLinkSentFromMobile === false?
      <p className="step-instructions">
        You can close this window and return to your computer to complete your verification.
      </p>:
      <div className="step-instructions">
        <p>
          We'll review the documents you submitted and let you know when your ID has been confirmed.
        </p>
        { registrationSubmittedAt && !idValidated?
        <p>
          Press Next below to proceed.
        </p> :
        <p>
          Press Next below to continue with the next step in the application process -
          submitting your work samples.
        </p> }
      </div> }
    </div>

    { magicLinkSentFromMobile !== false &&
    <div className="text-left">
      <button className="btn btn-tertiary btn-block" onClick={onNext}>Next</button>
    </div> }
  </div>
)

export default IdUploaded;



// WEBPACK FOOTER //
// ./registration/creative/components/id_uploaded.jsx